import { type TicketDetailModel } from '@/components/purchase/components/parkinglot/model'
import ExtendConfirmInfo from '@/components/purchase/components/shared/purchaseConfirmInfo/components/extendParkinglot/view'
import ParkinglotConfirmInfo from '@/components/purchase/components/shared/purchaseConfirmInfo/components/parkinglot/view'
import SharedConfirmInfo from '@/components/purchase/components/shared/purchaseConfirmInfo/components/sharedParkinglot/view'

import type { SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'

type ModalProps = {
  isOpen: boolean
  onClick: () => void
  onClose: () => void
}

export type ExtendConfirmInfoProps = ModalProps & {
  carNumValue: string
  price: number
  usingTime: number
}

export type SharedConfirmInfoProps = ModalProps & {
  carNumValue: string
  enteringTime: number
  price: number
  data: SharedParkinglotDetail
}

export type ParkinglotConfirmInfoProps = ModalProps & {
  carNumValue: string
  data: TicketDetailModel
}

const PurchaseConfirmInfoView = ({
  props
}: {
  props: ExtendConfirmInfoProps | SharedConfirmInfoProps | ParkinglotConfirmInfoProps
}) => {
  if ('usingTime' in props) {
    return <ExtendConfirmInfo {...props} />
  }
  if ('enteringTime' in props) {
    return <SharedConfirmInfo {...props} />
  }
  return <ParkinglotConfirmInfo {...props} />
}

export default PurchaseConfirmInfoView
